import { PbxHttpClient } from "@/services/httpclient";

const state = {
    allEvaluations: []
};

const getters = {
    GET_ALL_EVALUATIONS: state => state.allEvaluations
};

const mutations = {
    SET_ALL_EVALUATIONS: (state, payload) => (state.allEvaluations = payload),

    SET_EVALUATIONS: (state, payload) =>
        (state.allEvaluations = state.allEvaluations.concat(payload)),

    PUSH_EVALUATION: (state, payload) =>
        (state.allEvaluations = [...state.allEvaluations, payload]),

    UPDATE_EVALUATION: (state, payload) =>
        (state.allEvaluations = state.allEvaluations.map(ev =>
            ev.id === payload.id ? payload : ev
        )),

    DELETE_EVALUATION: (state, id) =>
        (state.allEvaluations = state.allEvaluations.filter(ev => ev.id !== id))
};

const actions = {
    async REGISTER_EVALUATION({ commit }, payload) {
        try {
            const response = await PbxHttpClient.post(
                `/quality/evaluation`,
                payload
            );
            //FOR TESTING
            // console.log(response.data)
            commit("PUSH_EVALUATION", response.data.evaluation);
            return;
        } catch (error) {
            return Promise.reject(error);
        }
    },
    async SHOW_EVALUATIONS({ commit, state }, page) {
        try {
            if (!page) {
                const response = await PbxHttpClient.get(`/quality/evaluation`);
                if (response.data.total !== state.allEvaluations.length)
                    commit("SET_ALL_EVALUATIONS", response.data.data);
                return response.data;
            } else {
                const response = await PbxHttpClient.get(
                    `/quality/evaluation?page=${page}`
                );
                //Compare if response items already exists in store
                const evaluationsStr = JSON.stringify(state.allEvaluations);
                const resStr = JSON.stringify(response.data.data);
                if (
                    !evaluationsStr.includes(
                        resStr.substring(1, resStr.length - 1)
                    )
                )
                    commit("SET_EVALUATIONS", response.data.data);
                return response.data;
            }
        } catch (error) {
            return Promise.reject(error);
        }
    },
    async SHOW_ALL_EVALUATIONS({ commit, state }) {
       try{
           const evaluations = []
           let nextPage = 1
           do {
               const {data} = await PbxHttpClient.get(
                   `/quality/evaluation?page=${nextPage}`
               );  
               evaluations.push(...data.data)
               nextPage = data.next_page_url ? data.current_page + 1 : 0
           } while (nextPage);
           commit("SET_ALL_EVALUATIONS", evaluations);

       }catch(err){
        console.log(err)
       }
    },
    async EDIT_EVALUATION({ commit }, { id, date, name }) {
        try {
            const payload = { date, name };
            const response = await PbxHttpClient.put(
                `/quality/evaluation/${id}`,
                payload
            );
            // console.log(response.data)
            commit("UPDATE_EVALUATION", response.data.evaluation);
        } catch (error) {
            return Promise.reject(error);
        }
    },

    async DELETE_EVALUATION({ commit }, id) {
        try {
            const res = await PbxHttpClient.delete(`/quality/evaluation/${id}`);
            commit("DELETE_EVALUATION", id);
            return;
        } catch (error) {
            return Promise.reject(error);
        }
    }
};

// Exportar Clientes
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
